import { classNames } from "@ember-decorators/component";
import ComboBoxComponent from "discourse/select-kit/components/combo-box";
import {
  pluginApiIdentifiers,
  selectKitOptions,
} from "discourse/select-kit/components/select-kit";

@pluginApiIdentifiers("circles-user-dropdown")
@selectKitOptions({
  caretDownIcon: "caret-right",
  caretUpIcon: "caret-down",
})
@classNames("circles-user-dropdown")
export default class UserDropdown extends ComboBoxComponent {
  valueProperty = "username";
  labelProperty = "username";

  modifyComponentForRow() {
    return "user-chooser/user-row";
  }
}
